module.exports = __webpack_public_path__ + "static/media/product.73f1250a.png";